<template>
    <div class="v-atlas-simple-geodata-feature-info">
        <template v-if="compiledFeatureTemplate">
            <component :is="compiledFeatureTemplate" v-if="compiledFeatureTemplate" :data="getFeatureResponse"
                :map-module="mapModule" @on-location-button-click="onLocationButtonClick" />
        </template>

        <template v-else>
            <PropertyGrid :object="getFeatureResponse?.feature?.properties" :config="propertyGridConfig" />
        </template>
    </div>
</template>

<script setup lang="ts">


import { PropertyGrid, useSmartFetch, ViewStackController } from "gertrud";
import { ShallowRef, computed, defineComponent, shallowRef, watch } from "vue";

import { SimpleGeodataMapModule } from "../simpleGeodata/SimpleGeodataMapModule";

const props = defineProps<{
    featureId: string
    mapModule: SimpleGeodataMapModule
    viewStackController: ViewStackController
}>()

const getFeatureUrl = () => props.mapModule?.moduleConfig?.serviceBaseUrl + "/features/" + props.featureId;


const getTemplateUrl = () => props.mapModule?.moduleConfig?.featureInfoTemplateUrl || ""

const compiledFeatureTemplate: ShallowRef<any> = shallowRef(null)

const { data: featureTemplateText } = useSmartFetch<string>(getTemplateUrl)

watch(featureTemplateText, (templateString) => {
    if (templateString) {
        compiledFeatureTemplate.value = defineComponent({
            props: {
                data: {
                    type: Object,
                    default: () => ({})
                },
                mapModule: {
                    type: SimpleGeodataMapModule,
                    default: () => (props.mapModule)
                }
            },
            template: templateString
        })
    }
})

function onLocationButtonClick(coordinates?: [number, number]) {


    if (coordinates) {


        props.mapModule.map?.flyTo(coordinates, 15)

    }
}

const { data: getFeatureResponse } = useSmartFetch<any>(getFeatureUrl);
// Wrap in a local computed so atlas-client's Vue instance can auto-unwrap it in templates

const propertyGridConfig = computed(() => {

    return {
        showOnlyConfiguredFields: true,
        fields: {
            "name": {
                label: "Name"
            },
            "fairtrade.address.postalCode": {
                label: "PLZ"
            },
            "fairtrade.address.addressLocality": {
                label: "Ort"
            },
            "fairtrade.address.streetAddress": {
                label: "Straße"
            }
        }
    }
})



</script>
